import React from 'react';

import App from '../../containers/App';
import TestComponent from '../../components/TestComponent/TestComponent';

const IndexPage = () => (
  <App>
    <TestComponent />
  </App>
);

export default IndexPage;
